import { Injectable } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { BehaviorSubject, interval } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppServiceService } from './app-service.service';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {
  public notificationlistener: BehaviorSubject<any>;

  private hubConnection: signalR.HubConnection;
  constructor(public appService: AppServiceService) {
    this.notificationlistener = new BehaviorSubject(null);
    this.appService.hubConnectionSubject.next(this.hubConnection);
  }

  // Connection Start
  public startConnection = async () => {
    if (this.hubConnection == undefined) {
      this.hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(environment.HUB_URL + 'hubalert?name=' + (await this.appService.loadUserProfile()).email, {
          // skipNegotiation: true,
          // transport: signalR.HttpTransportType.WebSockets,
          accessTokenFactory: () => this.appService.getUserToken()
        },)
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Debug)
        .build();
      this.hubConnection
        .start()
        .then(() => this.dataListener())
        .then(() => this.hubConnection.onclose(() => this.startConnection()))
        .catch(err => { interval(3000); this.startConnection() })
      this.appService.hubConnectionSubject.next(this.hubConnection);
    }
  }

  public dataListener = () => {
    this.hubConnection.on('maintenancealert', (data) => {
      this.notificationlistener.next(data);
    });
  }
}

